import React from "react";
import { Button, ButtonGroup } from "reactstrap";

import { isMobile } from "../../../utils/deviceInfo";
import { EDIT_SEE_PREVIEW } from "./editCopy";

// Desktop / Mobile in-page preview switch. The !isMobile guards are the
// pre-existing ones — on a mobile UA nothing here renders.
const EditSeePreviewCard = ({ view, setView }) => {
  if (isMobile) {
    return null;
  }

  return (
    <div className="bwai-edit-rt-card bwai-edit-preview-card">
      <div className="bwai-edit-rt-card-title">{EDIT_SEE_PREVIEW}</div>
      <ButtonGroup size="sm">
        <Button
          onClick={() => setView("DESKTOP")}
          className={`px-4 py-2 trivia_view_switch ${
            view === "DESKTOP" ? "active" : ""
          }`}
        >
          Desktop
        </Button>

        <Button
          onClick={() => setView("MOBILE")}
          className={`px-4 py-2 trivia_view_switch ${
            view === "MOBILE" ? "active" : ""
          }`}
        >
          Mobile
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default EditSeePreviewCard;
